/* Knops dag-avond: veel foto's. Extra foto's (buiten de 11 vaste groepen) swipen binnen de bestaande
   liggende en staande secties i.p.v. onderaan gestapeld te staan. Eigen CSS wordt hieronder geinjecteerd,
   zodat het Liquid-bestand onder de 256 KB blijft. */
(function () {
  var st0 = document.querySelector('[data-story]'); if (!st0) return;
  var secEl = st0.closest('[id^="shopify-section-"]'); if (!secEl) return;
  var st = document.createElement('style');
  st.textContent = (`
  /* ===== Veel foto's: extra foto's zitten ín de bestaande secties (swipen) i.p.v. een stapel onderaan ===== */
  @@SEC@@ .kp-car-wrap { position: relative; }
  @@SEC@@ .kp-car-arrow {
    position: absolute; top: 50%; transform: translateY(-50%); z-index: 6;
    background: rgba(0,0,0,0.45); border: 0; color: #fff; width: 44px; height: 44px;
    border-radius: 50%; font-size: 22px; line-height: 1; cursor: pointer; opacity: 0;
    transition: opacity 0.2s ease, background 0.2s ease;
  }
  @@SEC@@ .kp-car-wrap:hover .kp-car-arrow { opacity: 1; }
  @@SEC@@ .kp-car-arrow:hover { background: rgba(0,0,0,0.7); }
  /* foto-popup: gouden pijlen, ruimte voor menu links en Collections-tab rechts */
  @@SEC@@ .kp-gal__nav {
    background: rgba(10,8,5,0.45); color: #cc9f5a; border: 1px solid rgba(204,159,90,0.55);
  }
  @@SEC@@ .kp-gal__nav:hover { background: rgba(10,8,5,0.7); border-color: rgba(204,159,90,0.95); color: #e0b872; }
  @media (min-width: 701px) {
    @@SEC@@ .kp-gal__nav--prev { left: 120px; }
    @@SEC@@ .kp-gal__nav--next { right: 90px; }
  }
  /* afsluiting: 2 projecten onder elkaar (links) + 1 hoge collectiekaart (rechts) */
  @media (min-width: 1001px) {
    @@SEC@@ .kp-rgrid:has(.kp-rc--coll) .kp-rc.kp-rc:not(.kp-rc--coll) { grid-column: 1 / span 7; grid-row: auto / span 1; }
    @@SEC@@ .kp-rgrid:has(.kp-rc--coll) .kp-rc.kp-rc--coll { grid-column: 8 / span 5; grid-row: 1 / span 2; }
    @@SEC@@ .kp-rgrid:has(.kp-rc--coll) .kp-rc--coll .kp-rc__discover { font-size: clamp(22px, 2.4vw, 44px); }
  }
  /* subtiele gouden pijlen */
  @@SEC@@ .kp-story__swipe-arrow, @@SEC@@ .kp-car-arrow {
    background: rgba(10,8,5,0.38); color: #cc9f5a; border: 1px solid rgba(204,159,90,0.55);
    -webkit-backdrop-filter: blur(4px); backdrop-filter: blur(4px);
  }
  @@SEC@@ .kp-story__swipe-arrow:hover, @@SEC@@ .kp-car-arrow:hover {
    background: rgba(10,8,5,0.6); border-color: rgba(204,159,90,0.95); color: #e0b872;
  }
  @@SEC@@ .kp-car-arrow--prev { left: 1rem; }
  @@SEC@@ .kp-car-arrow--next { right: 1rem; }
  @media (min-width: 701px) {
    @@SEC@@ .kp-story__swipe-arrow--prev, @@SEC@@ .kp-car-arrow--prev { left: 120px; }
    @@SEC@@ .kp-story__swipe-arrow--next, @@SEC@@ .kp-car-arrow--next { right: 90px; }
  }
  @@SEC@@ .kp-car-arrow.is-off { opacity: 0 !important; pointer-events: none; }
  @media (hover: none) { .kp-car-arrow { display: none; } }
  @@SEC@@ .kp-car-count {
    position: absolute; right: 1.1rem; bottom: 1rem; z-index: 6; padding: 4px 11px; border-radius: 999px;
    background: rgba(0,0,0,0.45); color: #fff; font-family: 'Oswald', sans-serif; font-size: 12px; letter-spacing: 0.1em;
    pointer-events: none;
  }
  /* Liggende foto (volle breedte) met meerdere foto's: horizontale swipe-track */
  @@SEC@@ .kp-fullcar {
    display: flex; height: 100%; overflow-x: auto; scroll-snap-type: x mandatory;
    scrollbar-width: none; -webkit-overflow-scrolling: touch; overscroll-behavior-x: contain;
  }
  @@SEC@@ .kp-fullcar::-webkit-scrollbar { display: none; }
  @@SEC@@ .kp-fullcar__slide { position: relative; flex: 0 0 100%; height: 100%; scroll-snap-align: center; background: #111; }
  @@SEC@@ .kp-fullcar__slide img { width: 100%; height: 100%; object-fit: cover; display: block; }
  /* Staande foto's (rij) met meer foto's dan er passen: horizontaal swipen (op mobiel regelt de bestaande rij-swipe dit al) */
  @media (min-width: 701px) {
    @@SEC@@ .kp-story__row.kp-story__row--car {
      --kp-car-gap: clamp(6px, 0.8vw, 14px);
      flex-wrap: nowrap; overflow-x: auto; scroll-snap-type: x mandatory; scrollbar-width: none;
      -webkit-overflow-scrolling: touch; overscroll-behavior-x: contain;
    }
    @@SEC@@ .kp-story__row--car::-webkit-scrollbar { display: none; }
    @@SEC@@ .kp-story__row--car .kp-story__cell {
      flex: 0 0 calc((100% - (var(--kp-n, 3) - 1) * var(--kp-car-gap)) / var(--kp-n, 3)); scroll-snap-align: start;
    }
    @@SEC@@ .kp-story__row--car.is-single .kp-story__cell { flex-basis: min(520px, 46vw); scroll-snap-align: center; }
    @@SEC@@ .kp-story__row--car.is-single { justify-content: flex-start; }
  }
`).split('@@SEC@@').join('html #' + secEl.id);
  document.head.appendChild(st);
})();

/* Veel foto's: foto's die niet in de 11 vaste groepen passen worden niet meer onderaan gestapeld,
   maar zitten als extra swipe-foto's in de bestaande liggende (volle breedte / swipe) en staande (rij) secties. */
(function(){
  var storyEl=document.querySelector('[data-story]'); if(!storyEl) return;
  var root=storyEl.closest('[id^="shopify-section-"]')||document;
  var done=false;
  var ARR={prev:'&#8249;',next:'&#8250;'};
  function mkArrow(dir){ var b=document.createElement('button'); b.type='button'; b.className='kp-car-arrow kp-car-arrow--'+dir; b.setAttribute('aria-label',dir==='prev'?'Previous':'Next'); b.innerHTML=ARR[dir]; return b; }
  /* ---------- beeldkenmerken (helderheid + 4x4 kleurraster) voor clusteren op wat je ziet ---------- */
  function thumbUrl(src){
    if(!src) return src;
    if(/([?&])width=\d+/.test(src)) return src.replace(/([?&])width=\d+/,'$1width=64');
    return src+(src.indexOf('?')>-1?'&':'?')+'width=64';
  }
  function sampleOne(img){
    return new Promise(function(resolve){
      var src=thumbUrl(img.getAttribute('src')); var settled=false;
      var fallback=function(){ if(settled) return; settled=true; var r=parseFloat(img.getAttribute('data-r'))||1; resolve({b:0.5,r:r,f:null,bl:0}); };
      if(!src){ fallback(); return; }
      var t=setTimeout(fallback,4000);
      var im=new Image(); im.crossOrigin='anonymous';
      im.onload=function(){
        if(settled) return;
        try{
          var S=16, c=document.createElement('canvas'); c.width=S; c.height=S;
          var cx=c.getContext('2d'); cx.drawImage(im,0,0,S,S);
          var d=cx.getImageData(0,0,S,S).data, f=new Array(48).fill(0), cnt=new Array(16).fill(0), tot=0, sr=0, sb=0;
          for(var y=0;y<S;y++) for(var x=0;x<S;x++){
            var i=(y*S+x)*4, g=((y>>2)*4)+(x>>2);
            f[g*3]+=d[i]; f[g*3+1]+=d[i+1]; f[g*3+2]+=d[i+2]; cnt[g]++;
            tot+=0.299*d[i]+0.587*d[i+1]+0.114*d[i+2]; sr+=d[i]; sb+=d[i+2];
          }
          for(var k=0;k<48;k++) f[k]=f[k]/cnt[(k/3)|0]/255;
          settled=true; clearTimeout(t);
          resolve({b:tot/(S*S)/255,r:im.naturalHeight?im.naturalWidth/im.naturalHeight:1,f:f,bl:(sb-sr)/(S*S)/255});
        }catch(e){ clearTimeout(t); fallback(); }
      };
      im.onerror=function(){ clearTimeout(t); fallback(); };
      im.src=src;
    });
  }
  function dist(a,b){
    if(!a||!b) return 0;
    var s=0; for(var i=0;i<a.length;i++){ var d=a[i]-b[i]; s+=d*d; } return Math.sqrt(s/a.length);
  }
  function mean(list){
    var fs=list.filter(function(x){ return x&&x.f; }); if(!fs.length) return null;
    var m=new Array(48).fill(0); fs.forEach(function(x){ for(var i=0;i<48;i++) m[i]+=x.f[i]; });
    return m.map(function(v){ return v/fs.length; });
  }
  function otsu(vals){
    if(vals.length<4) return 0.3;
    var bins=new Array(32).fill(0); vals.forEach(function(v){ bins[Math.min(31,Math.floor(v*32))]++; });
    var total=vals.length, sum=0; for(var i=0;i<32;i++) sum+=i*bins[i];
    var wB=0,sB=0,best=-1,th=8;
    for(var t=0;t<32;t++){ wB+=bins[t]; if(!wB) continue; var wF=total-wB; if(!wF) break; sB+=t*bins[t];
      var mB=sB/wB, mF=(sum-sB)/wF, v=wB*wF*(mB-mF)*(mB-mF); if(v>best){ best=v; th=t; } }
    return Math.max(0.2,Math.min(0.42,(th+1)/32));
  }
  function swapPhoto(a,b){
    ['src','alt','data-src0','data-sample-src','data-r'].forEach(function(at){
      var va=a.getAttribute(at), vb=b.getAttribute(at);
      if(vb===null) a.removeAttribute(at); else a.setAttribute(at,vb);
      if(va===null) b.removeAttribute(at); else b.setAttribute(at,va);
    });
    var t=a._kp; a._kp=b._kp; b._kp=t;
  }
  function absorb(){
    if(done) return; done=true;
    var slots=Array.prototype.slice.call(storyEl.querySelectorAll('.kp-story__slot[data-kp-extra]'));
    if(!slots.length) return;
    var all=Array.prototype.filter.call(storyEl.querySelectorAll('img.kp-story-photo'),function(im){ return !im.closest('.kp-story__cell-wrap'); });
    Promise.all(all.map(function(im){ return sampleOne(im).then(function(k){ im._kp=k; }); }))
      .then(function(){ build(slots,all); },function(){ build(slots,all); });
  }
  function build(slots,all){
    all.forEach(function(im){ if(!im._kp) im._kp={b:0.5,r:parseFloat(im.getAttribute('data-r'))||1,f:null,bl:0}; });
    var isExtra=function(im){ return !!im.closest('[data-kp-extra]'); };
    var T=otsu(all.map(function(im){ return im._kp.b; }));
    /* avond = donker, of blauwe-uur (schemering): matig licht met blauwe/paarse tint */
    var isNight=function(im){ var k=im._kp; return k.b<T || (k.b<T+0.16 && k.bl>0.025) || k.bl>0.07 && k.b<0.5; };

    // "After Dark"-slot = begin van de avondzone
    var allSlots=Array.prototype.slice.call(storyEl.querySelectorAll('.kp-story__slot'));
    var nightSlotEl=null;
    allSlots.forEach(function(sl){
      if(nightSlotEl||sl.hasAttribute('data-kp-extra')) return;
      var h=sl.querySelector('.kp-story__project-title, .kp-story__pq-eyebrow, .kp-story__heading');
      if(h&&/after\s*dark/i.test(h.textContent||'')) nightSlotEl=sl;
    });
    var zoneOf=function(el){
      if(!nightSlotEl) return 'day';
      if(nightSlotEl===el||nightSlotEl.contains(el)) return 'night';
      return (nightSlotEl.compareDocumentPosition(el)&Node.DOCUMENT_POSITION_FOLLOWING)?'night':'day';
    };
    var wantsCell=function(im){ return !!im.closest('.kp-story__cell'); };
    var fitsHost=function(host,cand){ return wantsCell(host)?cand._kp.r<0.95:cand._kp.r>=0.95; };

    // 1) hoofd-slots met een foto van de verkeerde dag/avond-soort wisselen met een extra foto
    var mains=all.filter(function(im){ return !isExtra(im); });
    var pool=all.filter(isExtra);
    if(nightSlotEl) mains.forEach(function(m){
      var z=zoneOf(m), wantNight=(z==='night');
      if(isNight(m)===wantNight) return;
      var cands=pool.filter(function(c){ return isNight(c)===wantNight && fitsHost(m,c); });
      if(!cands.length) return;
      cands.sort(function(x,y){ return wantNight?(y._kp.b-x._kp.b):(y._kp.b-x._kp.b); });
      var pick=cands[wantNight?0:Math.floor(cands.length/2)];
      swapPhoto(m,pick);
    });

    // 2) rest in liggend/staand + dag/avond indelen
    var extraImgs=pool.slice();
    var extraGroups={dayL:[],dayP:[],nightL:[],nightP:[]};
    extraImgs.forEach(function(im){
      var key=(isNight(im)&&nightSlotEl?'night':'day')+(im._kp.r>=0.95?'L':'P');
      extraGroups[key].push(im);
    });
    var main=function(sel){ return Array.prototype.filter.call(storyEl.querySelectorAll(sel),function(el){ return !el.closest('[data-kp-extra]'); }); };
    var landTargets=main('.kp-story__swipe, .kp-story__full').filter(function(el){ return !el.closest('.kp-story__cell-wrap'); });
    var rowTargets=main('.kp-story__row--portraits').filter(function(r){
      return r.children.length && Array.prototype.every.call(r.children,function(c){ return c.classList.contains('kp-story__cell'); });
    });
    var tail=slots[slots.length-1];
    function addSlotBefore(node,ref){ var sl=document.createElement('div'); sl.className='kp-story__slot'; sl.appendChild(node); ref.parentNode.insertBefore(sl,ref); }
    function makeSwipe(ref){
      var sw=document.createElement('div'); sw.className='kp-story__block kp-story__swipe'; sw.setAttribute('data-swipe','');
      sw.innerHTML='<button type="button" class="kp-story__swipe-arrow kp-story__swipe-arrow--prev" data-swipe-prev aria-label="Previous">&#8249;</button><button type="button" class="kp-story__swipe-arrow kp-story__swipe-arrow--next" data-swipe-next aria-label="Next">&#8250;</button><div class="kp-story__swipe-track" data-swipe-track></div>';
      addSlotBefore(sw,ref);
      var tr=sw.querySelector('[data-swipe-track]');
      sw.querySelector('[data-swipe-prev]').addEventListener('click',function(){ tr.scrollBy({left:-tr.clientWidth*0.8,behavior:'smooth'}); });
      sw.querySelector('[data-swipe-next]').addEventListener('click',function(){ tr.scrollBy({left:tr.clientWidth*0.8,behavior:'smooth'}); });
      return sw;
    }
    function makeRow(ref){
      var row=document.createElement('div'); row.className='kp-story__block kp-story__row kp-story__row--portraits';
      addSlotBefore(row,ref); return row;
    }
    var hasZone=function(list,z){ return list.some(function(t){ return zoneOf(t)===z; }); };
    // ontbrekende doelen aanmaken: avond onderaan, dag net voor "After Dark"
    if(extraGroups.dayL.length && !hasZone(landTargets,'day'))   landTargets.push(makeSwipe(nightSlotEl||tail));
    if(extraGroups.nightL.length && !hasZone(landTargets,'night')) landTargets.push(makeSwipe(tail));
    if(extraGroups.dayP.length && !hasZone(rowTargets,'day'))    rowTargets.push(makeRow(nightSlotEl||tail));
    if(extraGroups.nightP.length && !hasZone(rowTargets,'night')) rowTargets.push(makeRow(tail));

    // Clusteren: elke extra foto naar de sectie waarvan de bestaande foto's er het meest op lijken
    function targetImgs(t){ return Array.prototype.slice.call(t.querySelectorAll('img.kp-story-photo')).filter(function(i){ return !i.closest('[data-kp-extra]'); }); }
    function cluster(items,targets){
      var buckets=targets.map(function(){ return []; });
      if(!targets.length||!items.length) return buckets;
      var cents=targets.map(function(t){ return mean(targetImgs(t).map(function(i){ return i._kp; })); });
      var cap=Math.max(4,Math.ceil(items.length/targets.length*1.6));
      var ranked=items.map(function(im){
        var ds=cents.map(function(c){ return dist(im._kp.f,c); });
        return {im:im,ds:ds,best:Math.min.apply(null,ds)};
      }).sort(function(a,b){ return a.best-b.best; });
      ranked.forEach(function(it){
        var order=it.ds.map(function(d,i){ return {i:i,d:d+buckets[i].length*0.004}; }).sort(function(a,b){ return a.d-b.d; });
        for(var k=0;k<order.length;k++){ if(buckets[order[k].i].length<cap||k===order.length-1){ buckets[order[k].i].push({im:it.im,d:it.ds[order[k].i]}); break; } }
      });
      return buckets.map(function(b){ return b.sort(function(x,y){ return x.d-y.d; }).map(function(x){ return x.im; }); });
    }
    var landBuckets=landTargets.map(function(){ return []; });
    var rowBuckets=rowTargets.map(function(){ return []; });
    ['day','night'].forEach(function(z){
      var idxL=[],tl=[]; landTargets.forEach(function(t,i){ if(zoneOf(t)===z){ idxL.push(i); tl.push(t); } });
      cluster(extraGroups[z+'L'],tl).forEach(function(b,k){ landBuckets[idxL[k]]=b; });
      var idxR=[],tr=[]; rowTargets.forEach(function(t,i){ if(zoneOf(t)===z){ idxR.push(i); tr.push(t); } });
      cluster(extraGroups[z+'P'],tr).forEach(function(b,k){ rowBuckets[idxR[k]]=b; });
    });

    // ---- liggend: verdeel over liggende secties (om de beurt) ----
    landTargets.forEach(function(t,ti){
      var extra=landBuckets[ti]; if(!extra.length) return;
      if(t.classList.contains('kp-story__swipe')){
        var track=t.querySelector('[data-swipe-track]'); if(!track) return;
        extra.forEach(function(im){ var it=document.createElement('div'); it.className='kp-story__swipe-item'; it.appendChild(im); im.setAttribute('loading','lazy'); track.appendChild(it); });
      } else {
        // volle-breedte foto -> horizontale swipe-track met alle foto's
        var first=t.querySelector('img.kp-story-photo'); if(!first) return;
        var track2=document.createElement('div'); track2.className='kp-fullcar';
        var slides=[first].concat(extra);
        slides.forEach(function(im){ var sd=document.createElement('div'); sd.className='kp-fullcar__slide'; sd.appendChild(im); im.setAttribute('loading','lazy'); track2.appendChild(sd); });
        while(t.firstChild) t.removeChild(t.firstChild);
        t.appendChild(track2);
        t.classList.remove('is-portrait-safe'); t.style.backgroundImage='';
        // arrows + teller binnen het (overflow:hidden) volle-breedte-blok
        var prev=mkArrow('prev'), next=mkArrow('next'), cnt=document.createElement('span'); cnt.className='kp-car-count';
        t.classList.add('kp-car-wrap');
        t.appendChild(prev); t.appendChild(next); t.appendChild(cnt);
        var n=slides.length;
        function upd(){ var i=Math.round(track2.scrollLeft/Math.max(track2.clientWidth,1)); i=Math.max(0,Math.min(n-1,i)); cnt.textContent=(i+1)+' / '+n; prev.classList.toggle('is-off',i===0); next.classList.toggle('is-off',i>=n-1); }
        prev.addEventListener('click',function(){ track2.scrollBy({left:-track2.clientWidth,behavior:'smooth'}); });
        next.addEventListener('click',function(){ track2.scrollBy({left:track2.clientWidth,behavior:'smooth'}); });
        track2.addEventListener('scroll',function(){ requestAnimationFrame(upd); },{passive:true});
        // muis-slepen
        var down=false,sx=0,ss=0;
        track2.addEventListener('pointerdown',function(e){ if(e.pointerType==='touch') return; down=true; sx=e.clientX; ss=track2.scrollLeft; track2.style.scrollSnapType='none'; try{track2.setPointerCapture(e.pointerId);}catch(_){} });
        track2.addEventListener('pointermove',function(e){ if(!down||e.pointerType==='touch') return; track2.scrollLeft=ss-(e.clientX-sx); });
        var end=function(e){ if(!down) return; down=false; track2.style.scrollSnapType=''; var w=track2.clientWidth; track2.scrollTo({left:Math.round(track2.scrollLeft/w)*w,behavior:'smooth'}); };
        track2.addEventListener('pointerup',end); track2.addEventListener('pointercancel',end);
        upd();
      }
    });

    // ---- staand: verdeel over staande rijen; rij wordt horizontaal swipebaar ----
    rowTargets.forEach(function(row,ri){
      var extra=rowBuckets[ri]; if(!extra.length) return;
      var n0=Math.max(1,Math.min(3,row.children.length));
      extra.forEach(function(im){ var c=document.createElement('div'); c.className='kp-story__cell'; c.appendChild(im); im.setAttribute('loading','lazy'); row.appendChild(c); });
      row.classList.add('kp-story__row--car'); row.style.setProperty('--kp-n',n0);
      // desktop: pijlen rond de rij (op mobiel regelt de bestaande rij-swipe pijlen/puntjes)
      var wrap=document.createElement('div'); wrap.className='kp-car-wrap kp-story__block';
      row.classList.remove('kp-story__block');
      row.parentNode.insertBefore(wrap,row); wrap.appendChild(row);
      var prev=mkArrow('prev'), next=mkArrow('next'); wrap.appendChild(prev); wrap.appendChild(next);
      var step=function(){ var c=row.children[0]; return c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(row).columnGap||10):row.clientWidth; };
      var upd2=function(){ prev.classList.toggle('is-off',row.scrollLeft<4); next.classList.toggle('is-off',row.scrollLeft+row.clientWidth>=row.scrollWidth-4); };
      prev.addEventListener('click',function(){ row.scrollBy({left:-step()*n0,behavior:'smooth'}); });
      next.addEventListener('click',function(){ row.scrollBy({left:step()*n0,behavior:'smooth'}); });
      row.addEventListener('scroll',function(){ requestAnimationFrame(upd2); },{passive:true});
      var down=false,sx=0,ss=0;
      row.addEventListener('pointerdown',function(e){ if(e.pointerType==='touch'||window.innerWidth<=700) return; if(e.target.closest&&e.target.closest('.kp-tag-pin')) return; down=true; sx=e.clientX; ss=row.scrollLeft; row.style.scrollSnapType='none'; try{row.setPointerCapture(e.pointerId);}catch(_){} });
      row.addEventListener('pointermove',function(e){ if(!down) return; row.scrollLeft=ss-(e.clientX-sx); });
      var end2=function(){ if(!down) return; down=false; row.style.scrollSnapType=''; };
      row.addEventListener('pointerup',end2); row.addEventListener('pointercancel',end2);
      upd2();
    });

    all.forEach(function(im){ if(isNight(im)) im.setAttribute('data-kp-night','1'); else im.removeAttribute('data-kp-night'); });
    slots.forEach(function(sl){ if(sl.parentNode) sl.parentNode.removeChild(sl); });
    try{ window.dispatchEvent(new Event('resize')); }catch(_){}
  }
  function ready(){ return storyEl.classList.contains('is-story-ready'); }
  if(ready()) absorb();
  else {
    try{ new MutationObserver(function(m,obs){ if(ready()){ obs.disconnect(); absorb(); } }).observe(storyEl,{attributes:true,attributeFilter:['class']}); }catch(e){ setTimeout(absorb,2500); }
    setTimeout(absorb,4000);
  }
})();
